import { useCallback, useEffect, useState } from 'react';
import { Permissions, userHasPermission } from 'services/Authorization';
import { RequestStatus } from 'UI/constants/status';

import { getRegionalCardsData } from './RegionalDirectorCards.utils';

export const useRegionalDirectorCards = () => {
  const [cardsState, setCardsState] = useState({
    data: null,
    status: RequestStatus.Idle
  });

  const canAccessActivity = userHasPermission(Permissions.CommandCenter.Activity.CanUseModule);

  const getData = useCallback(async () => {
    setCardsState({ data: null, status: RequestStatus.Loading });
    try {
      const data = await getRegionalCardsData();
      setCardsState({ data, status: RequestStatus.Success });
    } catch (error) {
      setCardsState({ data: null, status: RequestStatus.Error });
    }
  }, []);

  useEffect(() => {
    getData();

    return () => {
      setCardsState({ data: null, status: RequestStatus.Idle });
    };
  }, [getData]);

  return {
    cardsState,
    canAccessActivity,
    getData
  };
};
